export const interfacePanelTitle = 'Hardware Interface';
